__turbopack_context__.v({
  "container": "ClientError-module-scss-module__GH-D7a__container",
  "image": "ClientError-module-scss-module__GH-D7a__image",
  "message": "ClientError-module-scss-module__GH-D7a__message",
  "primary": "ClientError-module-scss-module__GH-D7a__primary",
  "primarySubtitle": "ClientError-module-scss-module__GH-D7a__primarySubtitle",
  "primaryTitle": "ClientError-module-scss-module__GH-D7a__primaryTitle",
  "secondary": "ClientError-module-scss-module__GH-D7a__secondary",
});
